export let TabsRootDataAttributes = /*#__PURE__*/function (TabsRootDataAttributes) {
  /**
   * Indicates the direction of the activation (based on the previous selected tab).
   * @type {'left' | 'right' | 'up' | 'down' | 'none'}
   */
  TabsRootDataAttributes["activationDirection"] = "data-activation-direction";
  /**
   * Indicates the orientation of the tabs.
   * @type {'horizontal' | 'vertical'}
   */
  TabsRootDataAttributes["orientation"] = "data-orientation";
  return TabsRootDataAttributes;
}({});